import classes from './HowItWorksItem.module.css';

const HowItWorkItem = (props)=>{
    return (
        <li className={classes.HowItWorkItem} style={{borderBottom: props.border? '1px solid #f8e3f0': 'none'}} data-aos="fade-right">
            <div className={classes.HowItWorkItemNumber}>{props.number}</div>
            <div>
                <h5 className={classes.HowItWorkItemTitle}>{props.title}</h5>
                <p className={classes.HowItWorkItemDescription}>{props.description}</p>
            </div>
        </li>
    );
}

export default HowItWorkItem;